import {getField} from 'vuex-map-fields';

function hasAll(state) {
    return state.permissions.filter((permission) => permission.name.includes('All')).length != 0;
}
function hasPermission(state) {
    return (list) => {
        if (state.permissions == null)
            return false;
        if (hasAll(state)){
            return true;
        }
        return list.filter((name) => {
            return state.permissions.filter((permission) => permission.name.includes(name)).length != 0;
        }).length != 0;
    }
}
function canAdminAnnouncements(state) {
    var t = false;
    if (state.permissions == null || state.permissions.length == 0)
        return t;
    ['All', 'Web'].forEach((j) => { state.permissions.forEach((permission) => { if (permission.name.includes(j)) { t = true; return t; } }); })
    return t;
}
export default {
    getField,
    hasPermission,
    hasAll,
    canAdminAnnouncements
}
